module.exports = __webpack_public_path__ + "static/media/toast_icon_success.1be552df.svg";